import * as ObjectUtils from "@/utils/ObjectUtils";

export default {
  workListsIds(state) {
    return state.workListsIds;
  },
  currentWorkList(state) {
    return state.currentWorkList ? state.currentWorkList.worklistItems : [];
  },
  canisterAmountForOrder(state) {
    return ObjectUtils.getProperty(state.currentWorkList, "canisterAmountForOrder", null);
  },
  pillAmountForCheckData(state) {
    return ObjectUtils.getProperty(state.currentWorkList, "pillAmountForCheckData", null);
  },
  currentWorkListId(state) {
    return state.currentWorkList && state.currentWorkList.id;
  },
  inDatabaseCanistersCount(state) {
    const READY_FOR_PRODUCTION_STATUS = 0;
    const readyForProductionItems = state.currentWorkList.worklistItems.filter(
      item => item.statusId === READY_FOR_PRODUCTION_STATUS
    );
    return readyForProductionItems.length
      ? readyForProductionItems.map(o => o.amountOfCanisters).reduce((a, b) => a + b)
      : 0;
  }
};
